import { UniqueIdentifier } from '../../../../../types';
import { PricingPackagesFormValues } from '../../../store/features/packages/types';
import { getSingleProductIdsList } from '../getPreselectedPackageFormValues';
import { canIncludeBundledProductToPackage } from '../canIncludeBundledProductToPackage';

export function createPackageToSubmit(
  productsSelections: PricingPackagesFormValues['productsSelections'],
  bundledProductsMap: Record<string, string[]>,
) {
  const {
    productMultipleIds,
    productSingleIdsMap,
    optionsSingleMap,
    optionsMultipleMap,
  } = productsSelections;

  const productSingleIds = getSingleProductIdsList(productSingleIdsMap);
  const allProductIds = [...productMultipleIds, ...productSingleIds];

  return allProductIds.flatMap((productId) => {
    const productIdWithFirstIndex = `${productId}-0`;
    const productIdWithSecondIndex = `${productId}-1`;

    const isBundledProductAddable = canIncludeBundledProductToPackage(
      productId,
      allProductIds,
      bundledProductsMap,
    );

    if (!isBundledProductAddable) {
      return [];
    }

    const firstProductMultipleOptions =
      optionsMultipleMap[productIdWithFirstIndex] || [];
    const secondProductMultipleOptions =
      optionsMultipleMap[productIdWithSecondIndex] || [];

    const optionIds = [
      optionsSingleMap[productIdWithFirstIndex],
      optionsSingleMap[productIdWithSecondIndex],
      ...firstProductMultipleOptions,
      ...secondProductMultipleOptions,
    ].filter((id): id is UniqueIdentifier => !!id);

    return {
      productId,
      optionIds,
    };
  });
}
